import React, { useCallback } from "react";
import List from "@commonComponents/List";
import AddtionalSupplyChainForm from "@EUForms/addtionalSupplyChainForm";
import { useDispatch } from "react-redux";
import useValidationAES from "../../hooks/useValidationAES";
import { useTranslation } from "@hooks/useTranslation";

const AddtionalSupplyChainDetail = ({ dataSource, onBlur, onSelect, deleteData, isItemsTab = false,validationErrors, ...rest }) => {
  const { updateMerchActorsRoleTypeError,initHeaderTabAddSupChainActorValidation } = useValidationAES()
  const translate = useTranslation()
  const dispatch = useDispatch()
  const renderItem = useCallback((item) => {

    const onBlurHandler = (tableName, payload) => onBlur(tableName, payload)    

    const onSelectHandler = (id, tableName, params, name) => {
      onSelect(id, tableName, params)
      validationErrors && validationErrors()
      if (isItemsTab && (name === 'role')) { 
        dispatch(updateMerchActorsRoleTypeError({
          dataSource,
          key: name,
          value: params[name],
          tableName,
          merchandiseId: rest?.merchandiseId,
          invoiceIndex: rest?.invoiceIndex,
          itemIndex: rest?.itemIndex,
          translate
        }))
      } 
      if (!isItemsTab && (name === 'role')) {
        dispatch(initHeaderTabAddSupChainActorValidation())
        dispatch(initItemsTabValidation())
      }
    }
    const onDeleteHandler = async (id, tableName, params) => {
      await deleteData(id, tableName, params)
      if(isItemsTab) dispatch(updateMerchActorsRoleTypeError({
        dataSource,
        key: 'role',
        value: '',
        tableName,
        merchandiseId: rest?.merchandiseId,
        invoiceIndex: rest?.invoiceIndex,
        itemIndex: rest?.itemIndex,
        translate
      }))
      if(!isItemsTab){
        dispatch(initHeaderTabAddSupChainActorValidation())
        dispatch(initItemsTabValidation())
      }
    }

    return <AddtionalSupplyChainForm
      key={item.id}
      dataSource={item}
      onBlur={onBlurHandler}
      onSelect={onSelectHandler}
      deleteData={onDeleteHandler}
      {...rest}
    />
  }, [rest])


  return <List className="responsiveGridCss" dataSource={dataSource} renderItem={renderItem} />
}

export default React.memo(AddtionalSupplyChainDetail)
